import { Fragment } from 'react'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { useAuthStatus } from '@jotta/auth-client/useAuthStatus'
import { useBrandName } from '@jotta/grpc-connect-client/config'
import { CopyButton } from '@jotta/ui/CopyButton'
import { useVersion } from '@jotta/utils/frontendbackend'

import { PublicLayout } from '../components/Layout/PublicLayout'

export const VersionPageRoute = () => {
  const brandName = useBrandName()
  const { data } = useAuthStatus()
  const version = useVersion()

  const map = {
    'Client version': version,
    'Server version': data?.version,
    'Browser version': window.navigator.userAgent,
    'User ID': data?.username,
  }

  return (
    <PublicLayout section="version">
      <div className="flex flex-col items-center gap-4 p-16 text-center">
        <header className="title-sm py-4">
          <Trans>{brandName} version information</Trans>
        </header>

        {Object.entries(map).map(([header, value]) => {
          return (
            <Fragment key={header}>
              <header className="label-sm">{header}</header>
              <span className="pb-4 text-center">{value || '-'}</span>
            </Fragment>
          )
        })}

        <CopyButton
          value={JSON.stringify(map, undefined, 2)}
          buttonText={copied =>
            copied ? t`Copied to clipboard` : t`Copy to clipboard`
          }
        />
      </div>
    </PublicLayout>
  )
}
